import { observer } from 'mobx-react-lite'
import { Box, Typography } from 'shared/ui'
import { CropImage } from 'shared/ui/CropImage'
import { type AccountStore } from 'pages/settings/pages/personal/pages/account/store/accountStore'
import styles from './styles.module.scss'

type IUploadImageModalProps = {
  store: AccountStore
}

export const UploadPhotoModal = observer(({ store }: IUploadImageModalProps) => {
  const { cropImageStore } = store

  return (
    <>
      <Typography
        className={styles.subtitle}
        ariaLabel={'info'}
        variant={'body-md-medium'}
        tag={'div'}
        marginTop={3}
        marginBottom={24}
      >
        Drag to reposition
      </Typography>

      <Box display={'flex'} justifyContent={'center'} marginBottom={'14px'}>
        <CropImage store={cropImageStore} />
      </Box>
    </>
  )
})
